"use client";

import React from "react";
import { Phone, ArrowRight, ShieldCheck, CircleCheck as CheckCircle2 } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
const accessTypes = [{
  title: "Commercial",
  description: "Multi-storey developments, retail refits, and planned maintenance frameworks."
}, {
  title: "Residential",
  description: "Extensions, private renovations, chimney stacks, and domestic builds."
}, {
  title: "Roofing",
  description: "Independent access, edge protection, chimney scaffolds, and solar mounts."
}, {
  title: "Specialist Access",
  description: "Temporary roofs, bridge scaffolding, internal birdcages, and tight urban plots."
}];
const accreditations = ["NASC Member", "CHAS Accredited"];
export default function Ascot() {
  return <section id="ascothero" data-nav="dark" className="relative bg-secondary text-secondary-foreground py-16 sm:py-24 lg:py-28 overflow-hidden border-b border-border/20">
      {/* Subtle background scaffolding grid pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary-foreground to-transparent" aria-hidden="true" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Eyebrow / Region Badge */}
          <div className="inline-flex items-center gap-2 mb-6">
            <Badge variant="outline" className="border-primary/40 bg-secondary/80 text-secondary-foreground px-3 py-1 text-xs sm:text-sm font-medium rounded-full">
              <ShieldCheck className="size-3.5 text-primary" />
              Ascot &amp; East Berkshire Coverage
            </Badge>
          </div>

          {/* Main H1 */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-secondary-foreground mb-6 font-default">
            Scaffolding in Ascot
          </h1>

          {/* Proposition text */}
          <p className="text-lg sm:text-xl text-secondary-foreground/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            BMF Scaffolding provides commercial, residential, roofing, solar and specialist scaffolding in Ascot and the surrounding Berkshire area, including SL5.
          </p>

          {/* Action CTAs */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
            <Button asChild size="lg" className="w-full sm:w-auto font-semibold shadow-md">
              <Link to="/ContactRequestQuotePage">
                Request a quote
                <ArrowRight className="size-4 ml-1" />
              </Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto font-medium border-border/40 text-secondary-foreground hover:text-secondary-foreground bg-secondary/50 hover:bg-secondary/80 shadow-xs">
              <a href="tel:01344929900" className="text-secondary-foreground hover:text-secondary-foreground">
                <Phone className="size-4 mr-1 text-primary" />
                Call 01344 929900
              </a>
            </Button>
          </div>

          {/* Accreditations Row */}
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-8 pt-4 pb-10 border-t border-border/15">
            {accreditations.map((item, i) => <div key={item} data-index={i} className="flex items-center gap-2 text-xs sm:text-sm font-medium text-secondary-foreground/75">
                <CheckCircle2 className="size-4 text-primary" />
                <span>{item}</span>
              </div>)}
          </div>
        </div>

        {/* 4 Pillars Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mt-6 max-w-6xl mx-auto">
          {accessTypes.map((service, i) => <div key={service.title} data-index={i} className="rounded-lg bg-sidebar-accent/30 border border-sidebar-border/50 p-5 sm:p-6 transition-[background-color,border-color] duration-200 hover:bg-sidebar-accent/50 hover:border-sidebar-border">
              <h2 className="text-base sm:text-lg font-semibold text-secondary-foreground mb-2">
                {service.title}
              </h2>
              <p className="text-xs sm:text-sm text-secondary-foreground/70 leading-normal">
                {service.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}